const actions = {
  PAYPAL_INVITATION_BEGIN: 'PAYPAL_INVITATION_BEGIN',
  PAYPAL_INVITATION_SUCCESS: 'PAYPAL_INVITATION_SUCCESS',
  PAYPAL_INVITATION_ERR: 'PAYPAL_INVITATION_ERR',
  PAYPAL_DISCONNECT_BEGIN: 'PAYPAL_DISCONNECT_BEGIN',
  PAYPAL_DISCONNECT_SUCCESS: 'PAYPAL_DISCONNECT_SUCCESS',
  PAYPAL_DISCONNECT_ERR: 'PAYPAL_DISCONNECT_ERR',
  PAYPAL_GET_CARDS_BEGIN: 'PAYPAL_GET_CARDS_BEGIN',
  PAYPAL_GET_CARDS_SUCCESS: 'PAYPAL_GET_CARDS_SUCCESS',
  PAYPAL_GET_CARDS_ERR: 'PAYPAL_GET_CARDS_ERR',
  PAYPAL_GET_SETUP_TOKEN_BEGIN: 'PAYPAL_GET_SETUP_TOKEN_BEGIN',
  PAYPAL_GET_SETUP_TOKEN_SUCCESS: 'PAYPAL_GET_SETUP_TOKEN_SUCCESS',
  PAYPAL_GET_SETUP_TOKEN_ERR: 'PAYPAL_GET_SETUP_TOKEN_ERR',
  PAYPAL_EXCHANGE_TOKEN_BEGIN: 'PAYPAL_EXCHANGE_TOKEN_BEGIN',
  PAYPAL_EXCHANGE_TOKEN_SUCCESS: 'PAYPAL_EXCHANGE_TOKEN_SUCCESS',
  PAYPAL_EXCHANGE_TOKEN_ERR: 'PAYPAL_EXCHANGE_TOKEN_ERR',
  PAYPAL_DELETE_CARD_BEGIN: 'PAYPAL_DELETE_CARD_BEGIN',
  PAYPAL_DELETE_CARD_SUCCESS: 'PAYPAL_DELETE_CARD_SUCCESS',
  PAYPAL_DELETE_CARD_ERR: 'PAYPAL_DELETE_CARD_ERR',
  PAYPAL_SET_DEFAULT_CARD_BEGIN: 'PAYPAL_SET_DEFAULT_CARD_BEGIN',
  PAYPAL_SET_DEFAULT_CARD_SUCCESS: 'PAYPAL_SET_DEFAULT_CARD_SUCCESS',
  PAYPAL_SET_DEFAULT_CARD_ERR: 'PAYPAL_SET_DEFAULT_CARD_ERR',

  invitePaypalBegin: () => {
    return {
      type: actions.PAYPAL_INVITATION_BEGIN,
    };
  },
  invitePaypalSuccess: (data) => {
    return {
      type: actions.PAYPAL_INVITATION_SUCCESS,
      data,
    };
  },
  invitePaypalErr: (err) => {
    return {
      type: actions.PAYPAL_INVITATION_ERR,
      err,
    };
  },

  disconnectPaypalBegin: () => {
    return {
      type: actions.PAYPAL_DISCONNECT_BEGIN,
    };
  },
  disconnectPaypalSuccess: (data) => {
    return {
      type: actions.PAYPAL_DISCONNECT_SUCCESS,
      data,
    };
  },
  disconnectPaypalErr: (err) => {
    return {
      type: actions.PAYPAL_DISCONNECT_ERR,
      err,
    };
  },

  getPaypalCardsBegin: () => {
    return {
      type: actions.PAYPAL_GET_CARDS_BEGIN,
    };
  },
  getPaypalCardsSuccess: (data) => {
    return {
      type: actions.PAYPAL_GET_CARDS_SUCCESS,
      data,
    };
  },
  getPaypalCardsErr: (err) => {
    return {
      type: actions.PAYPAL_GET_CARDS_ERR,
      err,
    };
  },

  getPaypalSetupTokenBegin: () => {
    return {
      type: actions.PAYPAL_GET_SETUP_TOKEN_BEGIN,
    };
  },
  getPaypalSetupTokenSuccess: (data) => {
    return {
      type: actions.PAYPAL_GET_SETUP_TOKEN_SUCCESS,
      data,
    };
  },
  getPaypalSetupTokenErr: (err) => {
    return {
      type: actions.PAYPAL_GET_SETUP_TOKEN_ERR,
      err,
    };
  },

  exchangePaypalTokenBegin: () => {
    return {
      type: actions.PAYPAL_EXCHANGE_TOKEN_BEGIN,
    };
  },
  exchangePaypalTokenSuccess: (data) => {
    return {
      type: actions.PAYPAL_EXCHANGE_TOKEN_SUCCESS,
      data,
    };
  },
  exchangePaypalTokenErr: (err) => {
    return {
      type: actions.PAYPAL_EXCHANGE_TOKEN_ERR,
      err,
    };
  },

  deletePaypalCardBegin: () => {
    return {
      type: actions.PAYPAL_DELETE_CARD_BEGIN,
    };
  },
  deletePaypalCardSuccess: (data) => {
    return {
      type: actions.PAYPAL_DELETE_CARD_SUCCESS,
      data,
    };
  },
  deletePaypalCardErr: (err) => {
    return {
      type: actions.PAYPAL_DELETE_CARD_ERR,
      err,
    };
  },

  setDefaultPaypalCardBegin: () => {
    return {
      type: actions.PAYPAL_SET_DEFAULT_CARD_BEGIN,
    };
  },
  setDefaultPaypalCardSuccess: (data) => {
    return {
      type: actions.PAYPAL_SET_DEFAULT_CARD_SUCCESS,
      data,
    };
  },
  setDefaultPaypalCardErr: (err) => {
    return {
      type: actions.PAYPAL_SET_DEFAULT_CARD_ERR,
      err,
    };
  },
};
export default actions;
